var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCartShadowIcon = function SvgCartShadowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 95,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.5,
    cy: 90,
    rx: 50.5,
    ry: 5,
    fill: "#EEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 84.333a3.833 3.833 0 1 0 0-7.667 3.833 3.833 0 0 0 0 7.667ZM76.667 84.333a3.833 3.833 0 1 0 0-7.667 3.833 3.833 0 0 0 0 7.667ZM3.833 3.834h15.334L29.44 55.162a7.666 7.666 0 0 0 7.667 6.172h37.26a7.666 7.666 0 0 0 7.666-6.172l6.134-32.161H23",
    stroke: "#949494",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCartShadowIcon;